import "./Settings.scss";
import { useState, memo } from "react";
import { useMediaQuery } from "@mui/material";
import GreenButton from "../../components/GreenButton/GreenButton";
import GeneralSettings from "./GeneralSettings/GeneralSettings";
import CountriesCitiesRegions from "./CountriesCitiesRegions/CountriesCitiesRegions";
import Terms from "./Terms/Terms";
import Links from "./Links/Links";
import IntroductionPages from "./IntroductionPages/IntroductionPages";
import Sliders from "./Sliders/Sliders";
import AppLinks from "./AppLinks/AppLinks";

// Navigation configuration
const SETTINGS_NAVIGATION = [
  {
    id: "GeneralSettings",
    text: "اعدادات عامة",
    component: GeneralSettings,
  },
  {
    id: "CountriesCitiesRegions",
    text: "البلاد / المحافظات",
    component: CountriesCitiesRegions,
  },
  {
    id: "Terms",
    text: "الشروط والاحكام",
    component: Terms,
  },
  {
    id: "Links",
    text: "روابط تواصل معنا",
    component: Links,
  },
  {
    id: "IntroductionPages",
    text: "الصفحات التعريفية",
    component: IntroductionPages,
  },
  {
    id: "Sliders",
    text: "صور السلايدر",
    component: Sliders,
  },
  {
    id: "AppLinks",
    text: "روابط التطبيقات",
    component: AppLinks,
  },
];

// Navigation Buttons Component
const NavigationButtons = memo(({ currentView, onViewChange, isMobile }) => (
  <div className="btns-container">
    {SETTINGS_NAVIGATION.map(({ id, text }) => (
      <GreenButton
        key={id}
        text={text}
        size={isMobile ? "full" : "medium"}
        variant={currentView === id ? "fill" : "outlined"}
        onClick={() => onViewChange(id)}
      />
    ))}
  </div>
));

NavigationButtons.displayName = "NavigationButtons";

// Header Component
const SettingsHeader = memo(({ currentView, onViewChange, isMobile }) => (
  <div className="special-header">
    <p className="title">اعدادات النظام</p>
    <NavigationButtons
      currentView={currentView}
      onViewChange={onViewChange}
      isMobile={isMobile}
    />
  </div>
));

SettingsHeader.displayName = "SettingsHeader";

// Content Component
const SettingsContent = memo(({ currentView }) => {
  const CurrentViewComponent =
    SETTINGS_NAVIGATION.find((item) => item.id === currentView)?.component ||
    (() => null);

  return (
    <div className="" style={{ padding: "30px" }}>
      <CurrentViewComponent />
    </div>
  );
});

SettingsContent.displayName = "SettingsContent";

// Main Settings Component
const Settings = () => {
  const isMobile = useMediaQuery("(max-width:767px)");
  const [currentView, setCurrentView] = useState("GeneralSettings");

  return (
    <div className="settings">
      <SettingsHeader
        currentView={currentView}
        onViewChange={setCurrentView}
        isMobile={isMobile}
      />
      <SettingsContent currentView={currentView} />
    </div>
  );
};

export default Settings;
